import { Grid, IconButton, List, Tooltip, Typography } from '@mui/material';
import React, { useMemo, useState } from 'react';
import AppWrapper from '../../AppWrapper';
import ContentLoader from '../../components/ContentLoader';
import useAuth from '../../hooks/useAuth';
import { commonService } from '../../services';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import MaterialReactTable from 'material-react-table';
import CardQuick from '../../components/Card';
import DownloadIcon from '@mui/icons-material/Download';
const DocumentsPage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { user } = useAuth();
    const [data, setData] = React.useState([]);

    React.useEffect(() => {
        commonService.getDocuments().then((data) => {
            setData(data)
        })
    }, [])

    const columns = useMemo(
        () => [
            {
                accessorKey: 'description', //access nested data with dot notation
                header: 'Descrição',
            },

            {
                accessorKey: 'created_at', //normal accessorKey
                header: 'Data de Carregamento',
            },
            {
                accessorKey: 'url',
                header: '',
                enableSorting: false,
                size: 10,
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
                Cell: ({ cell, row }) => (
                    <Tooltip title="Descarregar Ficheiro">
                        <IconButton onClick={() => window.open(row.original.url, "_blank")}
                        >
                            <DownloadIcon />
                        </IconButton>
                    </Tooltip>

                ),
            },
        ],
        [],
    );
    return (
        <React.Fragment>
            <Grid container spacing={4}>
                <Grid item xs={12}>
                    <Typography variant='h1' fontWeight={600}>Documentos</Typography>
                </Grid>
                <Grid xs={12}>
                    <CardQuick>
                        <MaterialReactTable
                            columns={columns}
                            data={data}
                            enableFullScreenToggle={false}
                            localization={MRT_Localization_PT_BR}
                            enableFilters={false}
                            enableDensityToggle={false}
                            enableColumnFilters={false}
                            enableColumnOrdering={false}
                            enableHiding={false}
                            positionToolbarAlertBanner="bottom"
                            muiTableBodyCellProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTablePaginationProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiBottomToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTopToolbarProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTableHeadRowProps={{ sx: { backgroundColor: '#FFFFFF' } }}
                            muiTablePaperProps={{ sx: { boxShadow: 'none' } }}
                        />
                    </CardQuick>
                </Grid>
            </Grid>
            <ContentLoader open={isLoading} />
        </React.Fragment>


    )
}

export default DocumentsPage;

